export const getEnterpriseId = () => {
    const url = window.location.href.toLowerCase()
  if (url.indexOf('test-stg1') !== -1 || url.indexOf('test1') !== -1
  ) {
    return '66B08BC8A727412F82C49C0D09FDB504'
  } if (url.indexOf('test-stg5') !== -1 || url.indexOf('test5') !== -1
  ) {
    return 'F4D24F477EC94C72917B10F481279D2C'
  }
  return 'F119953996274F3982D9DD678E187A65' // 中车的企业代码
}